/*
 * @Description: 积分记录列表
 * @Author: guqiang
 * @Date: 2021-09-22 23:54:53
 * @LastEditors: guqiang
 * @LastEditTime: 2021-09-23 00:07:23
 */
/**
 * 积分管理
 */
import { COINRECORD } from '../types';

export default {
    name: `${COINRECORD}`,
    path: '/coinRecord',
    component: () => import(/* webpackChunkName: 'coinManage' */ '@/views/coinManage/'),
    redirect: { name: `${COINRECORD}Index` },
    meta: {
        title: '积分明细',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${COINRECORD}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'coinManage' */ '@/views/coinManage/home/Record.vue'),
        },
    ],
};
